<div
  #productTagGroupColumn
  *ngIf="colVm.columnType === productTagGroupColumnType"
  class="product-column-general product-product-tag"
  [style.visibility]="section?.collapseContent || rowVm?.collapseContent ? 'collapse' : ''"
  [style.text-decoration]="productStylingVm | forcedColumnTextDecoration: colVm : locConfig | async">
  <app-column-list-items
    [colVm]="colVm"
    [rowVm]="rowVm"
    [displayFormat]="displayFormat"
    [sectionColumnType]="productTagGroupColumnType"
    [columnListLayoutModifierClass]="columnListLayoutModifierClass"
    [parentColumnElement]="productTagGroupColumn">
  </app-column-list-items>
</div>
